var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1036_12188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.519 6.65723L23.4788 29.9057H8.52184L6.48209 6.65723L3.89746 6.88379L5.97446 30.5539C6.08377 31.6448 7.0304 32.5002 8.13009 32.5002H23.8706C24.9699 32.5002 25.9169 31.6453 26.028 30.5383L28.1037 6.88379L25.519 6.65723Z",
    fill: "url(#paint0_linear_1036_12188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7567 0.5H11.2432C10.051 0.5 9.08105 1.46994 9.08105 2.66219V6.77031H11.6756V3.09456H20.3242V6.77025H22.9188V2.66213C22.9189 1.46994 21.949 0.5 20.7567 0.5Z",
    fill: "url(#paint1_linear_1036_12188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8382 5.47314H2.16255C1.44598 5.47314 0.865234 6.05389 0.865234 6.77046C0.865234 7.48702 1.44598 8.06777 2.16255 8.06777H29.8382C30.5548 8.06777 31.1355 7.48702 31.1355 6.77046C31.1355 6.05389 30.5547 5.47314 29.8382 5.47314Z",
    fill: "url(#paint2_linear_1036_12188)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1036_12188",
    x1: 16.0006,
    y1: 6.65723,
    x2: 16.0006,
    y2: 32.5002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED2024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9B9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1036_12188",
    x1: 15.9999,
    y1: 0.5,
    x2: 15.9999,
    y2: 6.77031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED2024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9B9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1036_12188",
    x1: 16.0004,
    y1: 5.47314,
    x2: 16.0004,
    y2: 8.06777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED2024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9B9D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1036_12188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinIcon);
export default __webpack_public_path__ + "static/media/binIcon.6bc8c6e2f3f20574533999d05e68d3a0.svg";
export { ForwardRef as ReactComponent };